import { Autocomplete, Button, DateRange, Field, Filter } from "components/commons";
import SearchTypeField from "components/commons/search-field/search-type";
import VIPRedemptionStatus from "enums/vip-redemption-status";
import locale from "localization";
import React from "react";
import styles from "./redeem-points-filter.module.scss";

const searchTypeOptions = [
  { label: locale.vipRedemptionId, value: "vipRedemptionId" },
  { label: locale.cashInId, value: "cashinId" },
  { label: locale.businessName, value: "businessName" },
  { label: locale.businessId, value: "businessId" },
];

const statusOptions = [
  { label: locale.pending, value: VIPRedemptionStatus.Pending },
  { label: locale.success, value: VIPRedemptionStatus.Success },
  { label: locale.failed, value: VIPRedemptionStatus.Failed },
];

const RedeemPointsFilter = ({
  filterState,
  applyFilter,
  applyClearFilter,
  applyResetFilter,
  modifyFilter,
  modifySearch,
  applySearch,
  applyClearSearch,
  searchKey,
  filterCount,
  exportReport,
  exporting,
}) => {
  return (
    <div className={styles.filter}>
      <Filter
        submit={applyFilter}
        clear={applyClearFilter}
        close={applyResetFilter}
        filterCount={filterCount}
      >
        <Field
          labelPosition={"left"}
          childrenClassName={styles.fieldContent}
          label={locale.redemptionDate}
        >
          <DateRange
            value={{
              startDate: filterState.startDate,
              endDate: filterState.endDate,
            }}
            onChange={(_, { value }) => {
              const { startDate, endDate } = value;
              modifyFilter({
                startDate,
                endDate,
              });
            }}
          />
        </Field>
        <Field labelPosition={"left"} childrenClassName={styles.fieldContent} label={locale.status}>
          <Autocomplete
            capitalize={false}
            name={"statuses"}
            hasAll
            multiple
            placeholder="Select Status"
            value={filterState.statuses}
            options={statusOptions}
            onChange={(name, { value }) => {
              modifyFilter({ [name]: value });
            }}
          />
        </Field>
      </Filter>
      <Field className={styles.search}>
        <SearchTypeField
          placeholder={locale.keyword}
          value={searchKey}
          restrict={false}
          onChange={(_, { value }) => {
            modifySearch(value);
          }}
          onEnter={applySearch}
          onClear={applyClearSearch}
          searchKeyName={"searchType"}
          searchKeyValue={filterState.searchType}
          searchKeyOptions={searchTypeOptions}
          searchKeyOnChange={(name, { value }) => {
            modifyFilter({ [name]: value });
          }}
        />
      </Field>
      <Field className={styles.downloadButton}>
        <Button
          startIcon={<span className="icon-download" />}
          exportButton
          onClick={exportReport}
          disabled={exporting}
          loading={exporting}
        >
          {locale.export}
        </Button>
      </Field>
    </div>
  );
};

export default RedeemPointsFilter;
